import React, {useEffect} from 'react'
import { BrowserRouter as Router, Routes, Route,Navigate, redirect } from 'react-router-dom';

import Sockets from '../../utils/Sockets';
import MobileNavbar from './MobileNavbar'
import MobileTrade from './MobileTrade'
import MobileMyProfile from './MobileMyProfile';
import MobileSettings from './MobileSettings';
import MobileMyOrders from './MobileMyOrders';
import MobileConsole from "./MobileConsole"
import MobilePositions from './MobilePositions';

import useToolsStore from '../../stores/ToolsStore';
import useUserStore from '../../stores/UserStore';
import useTradeStore from '../../stores/TradesStore';
import useAlgoStore from '../../stores/AlgosStore';
import useTriggerStore from '../../stores/TriggersStore';
import useExchangeStore from '../../stores/ExchangesStore';
import useArbStore from '../../stores/ArbsStore';
import useConsoleStore from "../../stores/ConsoleStore";
import useSettingsStore from "../../stores/SettingsStore";
import useUserSettingStore from '../../stores/UserSettingsStore';
import usePositionsStore from '../../stores/PositionsStore';

function MobileAppContainer() {
    const { logOut } = useUserStore();
    const mobileComponent = useToolsStore(state => state.mobileComponent); 
    const { fetchTrades } = useTradeStore();
    const { fetchAlgos } = useAlgoStore();
    const { fetchTriggers } = useTriggerStore();
    const { fetchExchanges } = useExchangeStore();
    const { fetchArb } = useArbStore();
    const { fetchConsole } = useConsoleStore();
    const { fetchSettings } = useSettingsStore();
    const { fetchUserSettings } = useUserSettingStore();
    const { fetchPositions } = usePositionsStore()
    
    useEffect(() => {
        const fetchData = async () => {
          console.log('FETCHING DATA MOBILE')
          try {
            await fetchTrades();
            await fetchAlgos();
            await fetchTriggers();
            await fetchArb();
            await fetchConsole();
            await fetchSettings();
            await fetchExchanges();
            await fetchPositions();
            await fetchUserSettings();
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logOut();
            } else {
              console.log("Error fetching data", error);
            }
          }
        };
        fetchData();
      }, []);
      
  return (
    <div className='mobile_app_container'>
        <Sockets/>
        <MobileNavbar/>
        {mobileComponent === 'trades' && <MobileTrade />}
        {/* {mobileComponent === 'settings' && <MobileSettings />} */}
        {mobileComponent === 'my_orders' && <MobileMyOrders />}
        {mobileComponent === 'my_profile' && <MobileMyProfile />}
        {mobileComponent === 'console' && <MobileConsole />}
        {mobileComponent === 'positions' && <MobilePositions />}
    </div>
  )
}

export default MobileAppContainer